import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { ActionSheetController, LoadingController, ModalController, Platform, ToastController } from '@ionic/angular';
import { EmployeeVoiceService } from 'src/app/services/employee-voice.service';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File, FileEntry } from '@ionic-native/file/ngx';
import { WebView } from '@ionic-native/ionic-webview/ngx';
import { StatusHttp } from 'src/app/static';

@Component({
  selector: 'app-view-employee-voice',
  templateUrl: './view-employee-voice.page.html',
  styleUrls: ['./view-employee-voice.page.scss'],
})
export class ViewEmployeeVoicePage implements OnInit {

  @Input() message:any;
  @Input() fromWhere:any=null;
  comment:any;
  response;
  formData  = new FormData();
  nativeImageUrl:string;
  image:any;
  imageArray:any = [];
  voiceEmployee:string;
  selectSubject: string = '';
  private readonly otherInputValue = '11';
  otherSubject: string = '';
  voiceEmployeeData:any;
  active: boolean = false;
  isLoading: boolean = false;
  typePlatform:string;
  fileData:any;

  optionsCamera: CameraOptions = {
    quality:40,
    destinationType: this.camera.DestinationType.FILE_URI,
    sourceType: this.camera.PictureSourceType.CAMERA,
    mediaType: this.camera.MediaType.PICTURE,
    correctOrientation: true,
    encodingType: this.camera.EncodingType.JPEG,
    allowEdit:false,
    saveToPhotoAlbum: false
  }

  optionsGallery: CameraOptions = {
    quality: 40,
    destinationType: this.camera.DestinationType.FILE_URI,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    allowEdit:false,
    correctOrientation: true,
    sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
    saveToPhotoAlbum: true
  }

  constructor(
    private modalController:ModalController, 
    private employeeService:EmployeeVoiceService, 
    private router:Router,    
    private platform: Platform,
    public actionSheetController: ActionSheetController,
    private androidPermissions: AndroidPermissions,
    private camera: Camera,
    private file: File,
    private toastController:ToastController,
    private webview: WebView,
    public loadingCtrl: LoadingController,
  ) { 
    if(this.platform.is('cordova') && this.platform.is('ios'))  this.typePlatform = 'app';
     else  this.typePlatform = 'browser';
  }


  async ngOnInit() {
    await this.getComment();
    console.log(this.message);
  }
  async getComment() {
    try {
      const res: any = await this.employeeService.getComment(this.message.id).toPromise();
      console.log("getComment", res);
      if (res.data) {
        this.comment = res.data;
        this.comment.extra_voice_employee = this.comment.extra_voice_employee.slice().reverse();
      }
    } catch (error) {
      console.error('Error fetching comment:', error);
    }
  }
  close(){
    this.modalController.dismiss();
    if(this.fromWhere){
     this.router.navigate(['/dashboard']);
    }
  }

  reOpen(message){
    this.modalController.dismiss();
    this.router.navigate(["employee-voice/send-voice", { data: JSON.stringify(message)}]);
  }

  //funciones para foto
  async openOptions() {
    let action_buttons = [];
    if (this.platform.is('android')) {
      action_buttons = [
        { 
          text: 'Tomar foto',          
          handler: () => {
            this.takePicture();
            console.log('tomar foto clicked');
          }  
        },
        { 
          text: 'Seleccionar de galería',        
          handler: () => {
            this.getGalleryPicture();
            console.log('galeria clicked');
          } 
        },
        { text: 'Cancelar', role: 'cancel' }
      ];
    }else{
      action_buttons = [
        { 
          text: 'Tomar foto',          
          handler: () => {
            this.takePicture();
            console.log('tomar foto clicked');
          }  
        },
        { 
          text: 'Seleccionar de galería',        
          handler: () => {
            this.getGalleryPicture();
            console.log('galeria clicked');
          } 
        },
        { text: 'Cancelar', role: 'cancel' }
      ]; 
    }
    const actionSheet = await this.actionSheetController.create({
      header: 'Selecciona una opción',
      buttons: action_buttons
    });
    await actionSheet.present();
  }

    async takePicture(){
  
      if (this.platform.is('android')) {
        console.log('android');
        // To be able to save files on Android, we first need to ask the user for permission. 
        // We do not let the download proceed until they grant access
        await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA).then(
          result => {
            if (!result.hasPermission) {
              return this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.CAMERA);
            }
          }
        );
      }
  
      this.camera.getPicture(this.optionsCamera).then((imageURL) => {
        // imageData is either a base64 encoded string or a file URI
        // If it's base64 (DATA_URL):
        this.file.resolveLocalFilesystemUrl(imageURL)
        .then( (entry) => { 
          console.log(entry.toURL());
          (<FileEntry>entry).file(file => {
            // this is the actual file as File object
            this.readFile(file);
          });
          this.presentToast('Imagen cargada','success');
          this.nativeImageUrl = entry.toURL();
          this.image = this.webview.convertFileSrc(entry.toURL());
          this.imageArray.push(this.image);
          console.log(this.image);
        })
        .catch(err => {
          this.presentToast('File path resolver error: '+JSON.stringify(err),'danger')
        });
       }, (err) => {
        // Handle error
        this.presentToast('No pudimos tomar la foto. Inténtalo de nuevo.','danger')
       });
  }
  getGalleryPicture(){
    this.camera.getPicture(this.optionsGallery).then((imageURL) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64 (DATA_URL):
      //console.log(JSON.stringify(imageData));
      this.file.resolveLocalFilesystemUrl(imageURL)
      .then( (entry) => {
        (<FileEntry>entry).file(file => {
          // this is the actual file as File object
          this.readFile(file);
        });
        console.log(JSON.stringify(entry));
        console.log(entry.toURL());
        this.presentToast('Imagen cargada','success');
        this.nativeImageUrl = entry.toURL();
        this.image = this.webview.convertFileSrc(entry.toURL());
        this.imageArray.push(this.image);
        console.log(this.image);
      })
      .catch(err => {
        this.presentToast('File path resolver error: '+JSON.stringify(err),'danger')
      });
      }, (err) => {
      // Handle error
      this.presentToast('No pudimos abrir la galería. Inténtalo de nuevo.','danger')
      });
  }
  onFileChange(file){
    let reader = new FileReader();
    reader.onload = (event:any) =>{
      this.fileData = event.target.result;
      this.formData.append('document64', this.fileData);
      this.imageArray.push(this.fileData);
      this.formData.append('images[]', this.fileData);
    }
    reader.readAsDataURL(file.target.files[0]); 
    this.nativeImageUrl = "browser";
  }

  async send() {
    
    // if(this.voiceEmployee == "sameVoiceEmployee") {
    //   this.selectSubject = "sameVoiceEmployee";
    // }

    // if(this.voiceEmployee == "sameVoiceEmployee") {
    //   this.selectSubject = "sameVoiceEmployee";
    // }
      this.selectSubject = "sameVoiceEmployee";

      console.info("selectSubject: ",this.selectSubject);
      console.info("otherSubject: ",this.otherSubject);
    if(!this.isEmpty(this.selectSubject)){

      if( ( this.selectSubject != this.otherInputValue ) || ( this.selectSubject === this.otherInputValue && this.otherSubject != '' ) ){

        let data = { 
          comments: this.response.split('\n').join('<br>'), 
          is_anonyme:  this.active ? 'ANONIMO' : 'NO ANONIMO',
          voice_employee_subject_id:  this.selectSubject,
          same_voice_employee: this.voiceEmployee,
          voice_employee_id: this.comment.id, 
          other_subject:  this.selectSubject === this.otherInputValue ? this.otherSubject : undefined
        };
        console.info("data: ",data);
        console.info("commnet: ",this.comment);
        //console.log(this.nativeImageUrl);

        if(this.nativeImageUrl){
          this.formData.append('comments',data.comments);
          this.formData.append('is_anonyme',data.is_anonyme);
          this.formData.append('voice_employee_subject_id',data.voice_employee_subject_id);
          this.formData.append('voice_employee_id', data.voice_employee_id);

          if(typeof data.other_subject !== 'undefined'){
            this.formData.append('other_subject',data.other_subject);
          }
          let send = await this.employeeService.sendVoiceEmployee(this.formData);
          await this.getComment();
          this.presentToast('Mensaje enviado','success');
          setTimeout(() => {this.router.navigateByUrl('dashboard');}, 4000);
          // console.log('img',this.nativeImageUrl);
          // console.log('data',this.formData);

          // console.log('send',send);
        }else{
          this.presentLoading();
          this.employeeService.sendMessage(data)
            .subscribe(async (response: any) => {
              console.log("response");
              console.log(JSON.stringify(response));
              if (response.status === StatusHttp.Success) {
                await this.getComment();
                this.presentToast('Mensaje enviado','success');
                setTimeout(() => {this.router.navigateByUrl('dashboard');}, 4000);
                // this.router.navigateByUrl('/employee-voice/employee-voice-sent-modal');
              }else if(response.status === StatusHttp.ServerError){
                this.presentToast(response.errorMessage,'danger');
              }
              this.dismissLoading();
            },
            error=>{
              console.log(error);
              console.log(JSON.stringify(error));
              this.dismissLoading();
            }
          )
        }
      }else{
        console.log('Tema');
        this.presentToast('Escribe el tema o asunto.','danger');
      }
    }else{
      this.presentToast('Escribe el tema o asunto.','danger');
    }
  }

  //Alerts
  // Presenta el toast con el error
  async presentToast(msg,color) {
    const toast = await this.toastController.create({
        message: msg,
        duration: 5000,
        position: 'bottom',
        color: color,
        cssClass: 'toast',
    });
    toast.present();
  }

  private readFile(file: any) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const formData = new FormData();
      const imgBlob = new Blob([reader.result], { type: file.type });
      this.formData.append('document', imgBlob, file.name);
      this.formData.append('images[]', imgBlob, file.name);
    };
    reader.readAsArrayBuffer(file);
  }
  isEmpty(str) {
    return (!str || str.length === 0 );
  }
  async presentLoading() {
    this.isLoading = true;
    return await this.loadingCtrl.create({
    }).then((a) => {
      a.present().then(() => {
        if (!this.isLoading) {
          a.dismiss();
        }
      });
    });
  }
  // Cierre del loading
  async dismissLoading() {
    this.isLoading = false;
    return await this.loadingCtrl.dismiss();
  }
}